"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _constants = require("../../constants");

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const ValidationMessageContainer = _styledComponents.default.div`
	padding-top: 5px;
	min-height: 17px;

	${props => props.error && {
  color: _constants.colours.inputError
}}
`;
const DefaultInput = (0, _styledComponents.default)(({
  boxShadow,
  backgroundColor,
  children,
  ...props
}) => /*#__PURE__*/_react.default.createElement(_core.InputBase, props, children))`
	label + &.MuiInputBase-root {
		margin-top: 8px;
	}
	&.MuiInputBase-root input {
		border: ${props => props.border || props.border === 0 ? props.border : `1px solid ${_constants.colours.inputBorderColor}`};
		position: relative;
		border-radius: 4px;
		background-color: ${props => props.backgroundColor || _constants.colours.white};
		padding: 12px 16px;
		transition: border-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
			box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
	}
	&.MuiInputBase-root input:focus {
		box-shadow: ${props => props.boxShadow === 'none' ? 'none' : ` ${(0, _styles.fade)(_constants.colours.inputFocus, 0.25)} 0 0 0 0.2rem `};
		border-color: ${_constants.colours.inputFocus};
	}
	&.MuiInputBase-root input[aria-invalid='true'] {
		box-shadow: ${props => props.boxShadow === 'none' ? 'none' : ` ${(0, _styles.fade)(_constants.colours.inputError, 0.25)} 0 0 0 0.2rem `};
		border-color: ${_constants.colours.inputError};
	}

	&.MuiInputBase-root::placeholder {
		font-family: ${_constants.fonts.normal};
		color: ${_constants.colours.inputGrayTextColor};
	}
`;
const CustomLabel = (0, _styledComponents.default)(_core.InputLabel)`
	&.MuiInputLabel-root {
		font-size: ${_constants.fontSizes.body};
		font-weight: bold;
		padding-bottom: 5px;
		color: ${props => props.error ? _constants.colours.inputError : _constants.colours.font};
	}
`;

const Input = ({
  pattern,
  minLength,
  maxLength,
  infoText,
  onKeyPress,
  onPaste,
  validationMessage,
  error,
  label,
  required,
  ...props
}) => {
  const nameAcceptedCharsRegex = pattern ? new RegExp(`^(${pattern}+)$`, 'g') : null;

  const handleKeyPress = event => {
    if (nameAcceptedCharsRegex && !event.key.match(nameAcceptedCharsRegex)) {
      event.preventDefault();
    }

    if (onKeyPress) {
      onKeyPress(event);
    }
  };

  const handlePaste = event => {
    if (event.clipboardData) {
      const text = event.clipboardData.getData('Text');

      if (nameAcceptedCharsRegex && !text.match(nameAcceptedCharsRegex)) {
        event.preventDefault();
      }
    }

    if (onPaste) {
      onPaste(event);
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", null, label && /*#__PURE__*/_react.default.createElement(CustomLabel, {
    required: required,
    error: error
  }, label), /*#__PURE__*/_react.default.createElement(DefaultInput, _extends({}, props, {
    onKeyPress: handleKeyPress,
    onPaste: handlePaste,
    inputProps: {
      minLength,
      maxLength
    },
    error: error
  })), (error && validationMessage || infoText) && /*#__PURE__*/_react.default.createElement(ValidationMessageContainer, {
    error: error
  }, error && validationMessage || infoText));
};

Input.propTypes = {
  label: _propTypes.default.string,
  pattern: _propTypes.default.string,
  minLength: _propTypes.default.number,
  maxLength: _propTypes.default.number,
  infoText: _propTypes.default.node,
  onKeyPress: _propTypes.default.func,
  onPaste: _propTypes.default.func,
  validationMessage: _propTypes.default.node,
  error: _propTypes.default.bool,
  required: _propTypes.default.bool
};
Input.defaultProps = {
  label: null,
  pattern: null,
  minLength: null,
  maxLength: null,
  infoText: null,
  onKeyPress: null,
  onPaste: null,
  validationMessage: null,
  error: false,
  required: false
};
var _default = Input;
exports.default = _default;